const SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbzDN7Z1cXu3_YFnzsW4hunaPQa8cvjizUUH5uFC1ubf66m20S9-N2qf48BSTQzVjD10/exec';

class CardGradingForm {
  constructor() {
    this.currentStep = 1;
    this.totalSteps = 4;
    this.data = {
      card_game: '',
      grading_house: 'GRAAD',
      delivery_method: '',
      photos: [],
      cards: [] // lista carte
    };
    this.init();
  }

  init() {
    this.bindGameButtons();
    this.bindDeliveryButtons();
    this.bindPhotoUpload();
    this.updateProgress();
    this.addFirstCard();
  }

  // ─── MULTI-CARTA ───────────────────────────────────────────

  addFirstCard() {
    // La prima carta è già nel DOM, non aggiungiamo nulla
  }

  addCard() {
    const container = document.getElementById('cg-cards-container');
    if (!container) return;
    const count = container.querySelectorAll('.cg-card-entry').length + 1;
    const entry = document.createElement('div');
    entry.className = 'cg-card-entry';
    entry.innerHTML = `
      <div class="cg-card-entry-header">
        <span class="cg-card-entry-num">Carta ${count}</span>
        <button type="button" class="cg-card-remove-btn" onclick="cgForm.removeCard(this)">✕ Rimuovi</button>
      </div>
      <div class="cg-field">
        <label class="cg-label">Nome Carta <span>*</span></label>
        <input type="text" class="cg-input cg-card-name" placeholder="es. Charizard, Blue-Eyes White Dragon...">
      </div>
      <div class="cg-row">
        <div class="cg-field">
          <label class="cg-label">Set / Espansione <span>*</span></label>
          <input type="text" class="cg-input cg-card-set" placeholder="es. Base Set, LOB...">
        </div>
        <div class="cg-field">
          <label class="cg-label">Numero Carta <span>*</span></label>
          <input type="text" class="cg-input cg-card-number" placeholder="es. 4/102">
        </div>
      </div>
      <div class="cg-field">
        <label class="cg-label">Rarità <span>*</span></label>
        <input type="text" class="cg-input cg-card-rarity" placeholder="es. Holo Rare, Secret Rare...">
      </div>
    `;
    container.appendChild(entry);
    this.renumberCards();
  }

  removeCard(btn) {
    const entry = btn.closest('.cg-card-entry');
    const container = document.getElementById('cg-cards-container');
    if (container.querySelectorAll('.cg-card-entry').length <= 1) return; // almeno 1
    entry.remove();
    this.renumberCards();
  }

  renumberCards() {
    document.querySelectorAll('.cg-card-entry').forEach((entry, i) => {
      const label = entry.querySelector('.cg-card-entry-num');
      if (label) label.textContent = 'Carta ' + (i + 1);
    });
  }

  collectCards() {
    const cards = [];
    document.querySelectorAll('.cg-card-entry').forEach(entry => {
      cards.push({
        name: entry.querySelector('.cg-card-name')?.value.trim() || '',
        set: entry.querySelector('.cg-card-set')?.value.trim() || '',
        number: entry.querySelector('.cg-card-number')?.value.trim() || '',
        rarity: entry.querySelector('.cg-card-rarity')?.value.trim() || ''
      });
    });
    return cards;
  }

  // ─── GAME / DELIVERY / PHOTO ───────────────────────────────

  bindGameButtons() {
    document.querySelectorAll('.cg-game-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        document.querySelectorAll('.cg-game-btn').forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        this.data.card_game = btn.dataset.game;
      });
    });
  }

  bindDeliveryButtons() {
    document.querySelectorAll('.cg-delivery-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        document.querySelectorAll('.cg-delivery-btn').forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        this.data.delivery_method = btn.dataset.delivery;
        const addressField = document.getElementById('cg-address-field');
        if (addressField) {
          addressField.style.display = btn.dataset.delivery === 'Spedizione' ? 'block' : 'none';
        }
      });
    });
  }

  bindPhotoUpload() {
    const zone = document.getElementById('cg-upload-zone');
    const input = document.getElementById('cg-photo-input');
    if (!zone || !input) return;
    zone.addEventListener('click', () => input.click());
    zone.addEventListener('dragover', e => { e.preventDefault(); zone.classList.add('dragover'); });
    zone.addEventListener('dragleave', () => zone.classList.remove('dragover'));
    zone.addEventListener('drop', e => {
      e.preventDefault();
      zone.classList.remove('dragover');
      this.handleFiles(e.dataTransfer.files);
    });
    input.addEventListener('change', () => this.handleFiles(input.files));
  }

  handleFiles(files) {
    Array.from(files).forEach(file => {
      if (!file.type.startsWith('image/')) return;
      if (this.data.photos.length >= 5) return;
      const reader = new FileReader();
      reader.onload = e => {
        this.data.photos.push({ name: file.name, base64: e.target.result });
        this.renderPhotoPreviews();
      };
      reader.readAsDataURL(file);
    });
  }

  renderPhotoPreviews() {
    const container = document.getElementById('cg-photo-previews');
    if (!container) return;
    container.innerHTML = this.data.photos.map((p, i) => `
      <div class="cg-photo-preview">
        <img src="${p.base64}" alt="Foto ${i+1}">
        <button class="cg-photo-remove" onclick="cgForm.removePhoto(${i})">×</button>
      </div>
    `).join('');
  }

  removePhoto(index) {
    this.data.photos.splice(index, 1);
    this.renderPhotoPreviews();
  }

  // ─── NAVIGAZIONE ───────────────────────────────────────────

  nextStep() {
    if (!this.validateStep(this.currentStep)) return;
    if (this.currentStep < this.totalSteps) {
      this.currentStep++;
      this.updateProgress();
      this.showStep(this.currentStep);
      if (this.currentStep === this.totalSteps) this.renderSummary();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  prevStep() {
    if (this.currentStep > 1) {
      this.currentStep--;
      this.updateProgress();
      this.showStep(this.currentStep);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  showStep(step) {
    document.querySelectorAll('.cg-step').forEach(s => s.classList.remove('active'));
    const target = document.getElementById(`cg-step-${step}`);
    if (target) target.classList.add('active');
  }

  updateProgress() {
    document.querySelectorAll('.cg-step-item').forEach((item, i) => {
      const stepNum = i + 1;
      item.classList.remove('active', 'completed');
      if (stepNum === this.currentStep) item.classList.add('active');
      if (stepNum < this.currentStep) item.classList.add('completed');
    });
    document.querySelectorAll('.cg-step-line').forEach((line, i) => {
      line.classList.toggle('completed', i + 1 < this.currentStep);
    });
  }

  // ─── VALIDAZIONE ───────────────────────────────────────────

  validateStep(step) {
    this.hideError();
    if (step === 1) {
      if (!this.data.card_game) {
        this.showError('Seleziona il gioco della carta.');
        return false;
      }
      const cards = this.collectCards();
      for (let i = 0; i < cards.length; i++) {
        const c = cards[i];
        if (!c.name || !c.set || !c.number || !c.rarity) {
          this.showError(`Compila tutti i campi della carta ${i + 1}.`);
          return false;
        }
      }
    }
    if (step === 3) {
      const customerName = document.getElementById('cg-customer-name')?.value.trim();
      const email = document.getElementById('cg-customer-email')?.value.trim();
      const phone = document.getElementById('cg-customer-phone')?.value.trim();
      if (!customerName || !email || !phone) {
        this.showError('Compila tutti i dati cliente.');
        return false;
      }
      if (!this.data.delivery_method) {
        this.showError('Seleziona la modalità di consegna.');
        return false;
      }
      if (this.data.delivery_method === 'Spedizione') {
        const address = document.getElementById('cg-delivery-address')?.value.trim();
        if (!address) {
          this.showError('Inserisci l\'indirizzo di spedizione.');
          return false;
        }
      }
    }
    return true;
  }

  showError(msg) {
    const el = document.querySelector('.cg-step.active #cg-error-msg');
    if (el) { el.textContent = msg; el.style.display = 'block'; }
  }

  hideError() {
    document.querySelectorAll('#cg-error-msg').forEach(el => el.style.display = 'none');
  }

  // ─── RIEPILOGO ─────────────────────────────────────────────

  renderSummary() {
    const cards = this.collectCards();
    const cardsHtml = cards.map((c, i) => `
      <div class="cg-summary-row">
        <span class="cg-summary-key">Carta ${i + 1}</span>
        <span class="cg-summary-val">${c.name} — ${c.set} #${c.number} (${c.rarity})</span>
      </div>
    `).join('');

    const graadCode = document.getElementById('cg-graad-code')?.value.trim();

    const fields = {
      'Gioco': this.data.card_game,
      'Casa di Gradazione': this.data.grading_house,
      'Codice GRAAD': graadCode || '—',
      'Consegna': this.data.delivery_method,
      'Cliente': document.getElementById('cg-customer-name')?.value,
      'Email': document.getElementById('cg-customer-email')?.value,
      'Telefono': document.getElementById('cg-customer-phone')?.value,
      'Foto caricate': `${this.data.photos.length} foto`,
    };
    if (this.data.delivery_method === 'Spedizione') {
      fields['Indirizzo'] = document.getElementById('cg-delivery-address')?.value;
    }

    const container = document.getElementById('cg-summary-content');
    if (container) {
      container.innerHTML = cardsHtml + Object.entries(fields).map(([k, v]) => `
        <div class="cg-summary-row">
          <span class="cg-summary-key">${k}</span>
          <span class="cg-summary-val">${v || '—'}</span>
        </div>
      `).join('');
    }
  }

  // ─── SUBMIT ────────────────────────────────────────────────

  async submit() {
    const btn = document.getElementById('cg-submit-btn');
    if (btn) { btn.disabled = true; btn.textContent = 'Invio in corso...'; }

    const cards = this.collectCards();
    const graadCode = document.getElementById('cg-graad-code')?.value.trim() || '';

    const payload = {
      action: 'create',
      cards: cards,
      // retrocompatibilità prima carta
      card_name: cards[0]?.name || '',
      card_game: this.data.card_game,
      card_set: cards[0]?.set || '',
      card_number: cards[0]?.number || '',
      card_rarity: cards[0]?.rarity || '',
      grading_house: this.data.grading_house,
      graad_code: graadCode,
      delivery_method: this.data.delivery_method,
      delivery_address: document.getElementById('cg-delivery-address')?.value.trim() || '',
      customer_name: document.getElementById('cg-customer-name')?.value.trim(),
      customer_email: document.getElementById('cg-customer-email')?.value.trim(),
      customer_phone: document.getElementById('cg-customer-phone')?.value.trim(),
      notes: document.getElementById('cg-notes')?.value.trim() || '',
      photos_before: `${this.data.photos.length} foto caricate dal cliente`,
    };

    try {
      const res = await fetch(SCRIPT_URL, {
        method: 'POST',
        body: JSON.stringify(payload)
      });
      const result = await res.json();

      if (result.success) {
        this.showSuccess(result.request_number, payload, cards);
        const requests = JSON.parse(localStorage.getItem('cg_requests') || '[]');
        requests.push({ request_number: result.request_number, email: payload.customer_email, date: new Date().toISOString() });
        localStorage.setItem('cg_requests', JSON.stringify(requests));
      } else {
        this.showError(result.error || 'Errore durante l\'invio. Riprova.');
        if (btn) { btn.disabled = false; btn.textContent = 'Conferma e Invia'; }
      }
    } catch (err) {
      this.showError('Errore di connessione. Riprova tra qualche istante.');
      if (btn) { btn.disabled = false; btn.textContent = 'Conferma e Invia'; }
    }
  }

  // ─── SUCCESS + STAMPA ──────────────────────────────────────

  showSuccess(requestNumber, payload, cards) {
    document.querySelectorAll('.cg-step, .cg-progress, .cg-header').forEach(el => el.style.display = 'none');
    const success = document.getElementById('cg-success');
    if (success) {
      success.style.display = 'block';
      const numEl = document.getElementById('cg-request-number');
      if (numEl) numEl.textContent = requestNumber;
    }
    // Salva dati per stampa
    this._printData = { requestNumber, payload, cards };
  }

  printRequest() {
    if (!this._printData) return;
    const { requestNumber, payload, cards } = this._printData;
    const cardsRows = cards.map((c, i) => `
      <tr>
        <td>${i + 1}</td>
        <td>${c.name}</td>
        <td>${c.set}</td>
        <td>#${c.number}</td>
        <td>${c.rarity}</td>
      </tr>
    `).join('');

    const win = window.open('', '_blank');
    win.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="utf-8">
        <title>Modulo Gradazione ${requestNumber}</title>
        <style>
          body { font-family: Arial, sans-serif; padding: 40px; color: #0f172a; }
          h1 { font-size: 24px; margin-bottom: 4px; }
          .subtitle { color: #64748b; font-size: 14px; margin-bottom: 32px; }
          .request-id { font-size: 32px; font-weight: 900; color: #7C3AED; margin-bottom: 32px; }
          table { width: 100%; border-collapse: collapse; margin-bottom: 32px; }
          th { background: #7C3AED; color: white; padding: 10px 12px; text-align: left; font-size: 13px; }
          td { padding: 10px 12px; border-bottom: 1px solid #e2e8f0; font-size: 13px; }
          tr:nth-child(even) td { background: #f8fafc; }
          .info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-bottom: 32px; }
          .info-item { padding: 12px 16px; border: 1px solid #e2e8f0; border-radius: 8px; }
          .info-label { font-size: 11px; color: #64748b; text-transform: uppercase; margin-bottom: 4px; }
          .info-value { font-size: 14px; font-weight: 700; }
          .footer { margin-top: 48px; padding-top: 16px; border-top: 1px solid #e2e8f0; font-size: 12px; color: #94a3b8; text-align: center; }
          @media print { body { padding: 20px; } }
        </style>
      </head>
      <body>
        <h1>🏆 Games Time Aversa — Card Grading</h1>
        <div class="subtitle">Modulo di richiesta gradazione professionale</div>
        <div class="request-id">${requestNumber}</div>

        <h3>Carte da Gradare</h3>
        <table>
          <thead>
            <tr><th>#</th><th>Nome</th><th>Set</th><th>Numero</th><th>Rarità</th></tr>
          </thead>
          <tbody>${cardsRows}</tbody>
        </table>

        <div class="info-grid">
          <div class="info-item">
            <div class="info-label">Cliente</div>
            <div class="info-value">${payload.customer_name}</div>
          </div>
          <div class="info-item">
            <div class="info-label">Email</div>
            <div class="info-value">${payload.customer_email}</div>
          </div>
          <div class="info-item">
            <div class="info-label">Telefono</div>
            <div class="info-value">${payload.customer_phone}</div>
          </div>
          <div class="info-item">
            <div class="info-label">Consegna</div>
            <div class="info-value">${payload.delivery_method}${payload.delivery_address ? ' — ' + payload.delivery_address : ''}</div>
          </div>
          <div class="info-item">
            <div class="info-label">Casa di Gradazione</div>
            <div class="info-value">${payload.grading_house}</div>
          </div>
          <div class="info-item">
            <div class="info-label">Codice GRAAD</div>
            <div class="info-value">${payload.graad_code || '—'}</div>
          </div>
          <div class="info-item">
            <div class="info-label">Gioco</div>
            <div class="info-value">${payload.card_game}</div>
          </div>
          <div class="info-item">
            <div class="info-label">Data Richiesta</div>
            <div class="info-value">${new Date().toLocaleDateString('it-IT')}</div>
          </div>
        </div>

        <div class="footer">
          Games Time Aversa • gamestimeaversa.com • aversa@gamestime.it
        </div>
        <script>window.onload = function() { window.print(); }<\/script>
      </body>
      </html>
    `);
    win.document.close();
  }
}

let cgForm;
document.addEventListener('DOMContentLoaded', () => { cgForm = new CardGradingForm(); });
function cgNextStep() { cgForm.nextStep(); }
function cgPrevStep() { cgForm.prevStep(); }
function cgSubmit() { cgForm.submit(); }
function cgAddCard() { cgForm.addCard(); }
function cgPrintRequest() { cgForm.printRequest(); }
